export const BYTES_IN_KILOBYTE = 1024;
export const BYTES_IN_MEGABYTE = BYTES_IN_KILOBYTE * 1024;
